// extracted by mini-css-extract-plugin
module.exports = {"LayoutDashboard":"LayoutDashboard_LayoutDashboard__w_Fjw","LayoutDashboard__Body":"LayoutDashboard_LayoutDashboard__Body__4iaXh"};